import EventEmitter from "eventemitter3";
import RowList from "../grid/row-model";
import { Helper } from "../../helper";
import EpgChannel from "./epg-channel";
import EPGUtility from "./epg-utility";
import { EPG_STATUS } from "./epg-enum";
import { REQUEST_STATUS } from "../../enum";
import { fetchMultiRequest } from "../../models/data-service";
import EpgProgram from "./epg-program";

export default class EPGManager extends EventEmitter {

    url = ''
    channelRowList!: RowList
    currIndex = 0
    visibleItems = 3
    bufferItems = 2
    EPGChannelList: EpgChannel[] = []
    timerange
    status: EPG_STATUS = EPG_STATUS.NONE
    currTimeId:any;
    currDate:Date = new Date();
    channelInfo: {
        prev:EpgProgram|null,
        next:EpgProgram|null
    } = {prev:null, next:null}

    currentPlayingItem = {
        channelIndex: 0
    }
    loaded: boolean = false

    constructor(url = '', channelRowList: RowList | null = null) {
        super();
        this.url = url
        this.channelRowList = channelRowList!
        this.timerange = this.getTimeRange()
    }


    /**
     * Initialize function will be call for the first time when the
     * user selects any live item from grid. and will pass the current index of the item
     * This function will create the filtered time range for epg filtering and creation.
     * This functino will fetch the epg based on current index and buffer rows. for faster display.
     *
     * @param {number} [initialIndex=0]
     */
    async init(initialIndex = 0) {
        let isValidUrl = false
        let isValidRowList = false
        this.currIndex = initialIndex

        if (this.url && this.url !== '') {
            isValidUrl = true
        }
        if (this.channelRowList) {
            isValidRowList = true
        }
        this.timerange = this.getTimeRange()
        if (isValidRowList) {
            this.channelRowList = this.channelRowList
            this.getEpgList()
        } else if (isValidUrl) {
            this.fetchInitialUrl()
        }
    }

    /**
     * Starts the timmer for current time update it will update every 1 sec.
     */
    startCurrentTimer() {
        this.currTimeId = setInterval(this.updateCurrentTime.bind(this), 1000)
    }

    /**
     * Stops the timmer for current time update
     */
    stopCurrentTimer() {
        clearInterval(this.currTimeId)
    }

    /**
     * function will check for any change in program from epg or if user changes the channel.
     * which updates the program of current playing and the next changed program     *
     *
     * @param {boolean} [force=false]
     */
    updateCurrentTime(force=false) {
        const newDate = EPGUtility.getDeviceCurrentDateTime()
        newDate.setSeconds(0,0)
        if(force) {
            this.currDate = newDate
            this.dispatchEvent('onCurrentTime',{currDate: this.currDate})
            this.updateProgramInfo()
        } else {
            if((newDate-this.currDate)/1000/60 >= 1) {
                this.currDate = newDate
                this.dispatchEvent('onCurrentTime', {currDate: this.currDate})
                this.updateProgramInfo()
            }
        }

    }

    /**
     * updates the current program when change is happend in current channel or user selects different channel
     */
    updateProgramInfo(forceDispatchInitialProgram?:boolean) {
        const currPlayingRow = this.EPGChannelList[this.currentPlayingItem.channelIndex]
        const tprogram:EpgProgram = currPlayingRow?.getNowPlayingProgram(this.currDate)
        let program = new EpgProgram()
        const rowItem = this.channelRowList.videos[this.currentPlayingItem.channelIndex]
        if(!tprogram || tprogram.title == 'No Data') {
            program.title = rowItem.title
            program.type = 'post'
            program.actiontype = 'live'
            program.node_id = rowItem?.node_id
            program.uid = rowItem?.uid
            program.runtime = rowItem?.runtime
            program.actionkey = rowItem?.actionkey
        } else {
            program = {...tprogram}
            program.title = program.title
            program.type = 'post'
            program.actiontype = 'live'
            program.node_id = program.id
            program.uid = (program.uid || 0)
            program.runtime = program.duration
            program.actionkey = program.actionkey || (rowItem?.actionkey)
        }
        let shouldDispatch = false
        if(!this.channelInfo.next) {
            //set the next program info and dispatch
            this.channelInfo.next = program
            shouldDispatch =true
        } else if(this.channelInfo.next && this.channelInfo.next.id !== program.id) {
            this.channelInfo.prev = {...this.channelInfo.next}
            this.channelInfo.next = program
            shouldDispatch =true
        }
        if(shouldDispatch || forceDispatchInitialProgram) {
            this.dispatchEvent('onProgramChanged',{channelInfo: this.channelInfo})
        }
        this.dispatchEvent('onTimeupdate', null)
    }

    /**
     * call when the user changes channels
     */
    changeChannel(index:number, forceDispatchInitialProgram?:boolean) {
        this.currIndex = index
        this.currentPlayingItem.channelIndex = index
        if(this.loaded) {
            this.updateProgramInfo(forceDispatchInitialProgram)
        }
    }

    /**
     * fetch the row channels and fetch the epg url for the current thumbnail is selected from grid.
     */
    async fetchInitialUrl() {
        const rowStyle: { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } = Helper.getRowStyle()
        const rowData = {
            description: 'live',
            dynamic_deeplink: '',
            feed_type: 'show',
            name: 'LIVE TV',
            row_height: rowStyle.row_height,
            row_item_height: rowStyle.row_item_height,
            row_item_width: rowStyle.row_item_width,
            rowstyle: rowStyle.rowstyle,
            row_sub_type: '',
            row_type: 'live',
            url: this.url
        }
        this.channelRowList = new RowList(rowData)
        await this.channelRowList.fetchMoreVideos(0)
        await this.getEpgList()
    }

    async getEpgList() {
        if(!this.loaded) {
            this.EPGChannelList = await this.fetchEpgList()
        }
        await this.fetchEpgPrograms()
        this.currentPlayingItem.channelIndex = this.currIndex
        this.updateCurrentTime(true)
        this.startCurrentTimer()
        return
    }

    /**
     * fetch epg programs for for the current thumbnail is selected from grid.
     * and dispatch the onEpgLoaded event for the Video Screen.
     */
    async fetchEpgPrograms() {
        await this.fetchProgramDetails(this.currIndex)
        this.dispatchEvent('onEpgLoaded', null)
        this.loaded=true        
        this.changeChannel(this.currIndex, true)
        return
    }


    /**
     * function to dispatch a custom event. to the listener here it is the video-screen-live class.
     *
     * @param {string} eventType
     * @param {*} data
     */
    dispatchEvent(eventType:string, data:any) {
        const event = new CustomEvent(eventType,{
            detail: data
        })
        this.emit(eventType, event)
    }


    /**
     * fetch all channels from rowlist for displaying the channel details in epg display.
     */
    async fetchAllChannels() {
        let fetchListPromise: Promise<RowList>[] = []
        let index = 0
        while (index <= this.channelRowList?.totalPages - 1) {
            const status = this.channelRowList.fetchedPageList[index]
            if (!status) {
                fetchListPromise.push(this.channelRowList?.fetchMoreVideos(index))
            }
            index++
        }
        await Promise.all(fetchListPromise)
        return true
    }

    /**
     * fetch the channel nodes and then creates the epg lists and returns
     *
     * @async
     * @returns {unknown}
     */
    async fetchEpgList() {
        await this.fetchAllChannels()
        const epgList = this.channelRowList?.videos.map((item, index) => {
            const chObj = { index: index, epgType: item?.epg_type, name: item?.title, epgUrl: item?.epg_url }
            const epgChannel: EpgChannel = new EpgChannel()
            Object.assign(epgChannel, chObj)
            return epgChannel
        })
        return epgList
    }

    /**
     * finds the index of channel where epg is not yet requested
     * based on current selected.
     * if the current selected channel is not yet fetched it will return the current index.
     * if the current selected is already fetch (totally 6 epg will fetched as batch.)
     * then the next will be the 7 hence it will return 7.
     *
     * @param {*} currIndex
     * @param {*} prevIndex
     */
    getNextPrefetchingIndex(currIndex, prevIndex) {
        if (currIndex == prevIndex) return

        let nextFetchingIndex = currIndex
        let exit = false
        const incr = currIndex > prevIndex ? 1 : -1
        let shouldFetch = false
        let cnt = 0 
        while (!exit) {
            nextFetchingIndex += incr
            cnt++
            if(this.EPGChannelList[nextFetchingIndex]?.fetchStatus == REQUEST_STATUS.NONE){
                shouldFetch = true
                exit = true
            } else if(
                //cnt == (this.visibleItems + this.bufferItems) ||
                nextFetchingIndex >= this.EPGChannelList.length ||
                nextFetchingIndex<0
            ) {
                exit = true
            }
        }
        if(shouldFetch) {
            this.fetchProgramDetails(nextFetchingIndex)
        }
    }

    /**
     * Fetches the epg program details based on getNextPrefetchIndex.
     *
     * @async
     * @param {number} [index=0]
     * @returns {*}
     */
    async fetchProgramDetails(index = 0) {
        const isMultiFetch = true
        const fetchIndexList = this.getPrefetchIndexList(this.EPGChannelList, index, this.visibleItems, this.bufferItems)
        const fetchData: Promise<EpgChannel>[] = []
        const fetchDataUrlObj: [{index:number, url:string}] = []
        
        fetchIndexList.map((value: number) => {
            const channel = this.EPGChannelList[value]
            if(channel?.fetchStatus == REQUEST_STATUS.NONE) {
                //fetchData.push(this.EPGChannelList[value]?.fetchEpgPrograms(this.timerange)!)
                fetchDataUrlObj.push({
                    index:value,
                    url:channel.epgUrl
                })
                channel.fetchStatus = REQUEST_STATUS.FETCHING
            }
        })

        if(fetchDataUrlObj.length > 0) {
            const results = await fetchMultiRequest(fetchDataUrlObj.map(item=>item.url))
            results.data.map((data:EpgProgram[], index:number )=>{
                const channelIndx = fetchDataUrlObj[index]?.index
                const channel:EpgChannel = this.EPGChannelList[channelIndx]
                fetchData.push(channel.fetchEpgPrograms(this.timerange, data))
            })
        }
        
        
        if(fetchData.length > 0) {
             await Promise.all(fetchData)
        } else {
             return
        }
    }

    /**
     * This function will return a array of index to be fetched as batch.
     *
     * @param {any[]} orginalArray
     * @param {number} focusIndex
     * @param {number} visibleCount
     * @param {number} bufferCount
     * @returns {number[]}
     */
    getPrefetchIndexList(orginalArray: any[], focusIndex: number, visibleCount: number, bufferCount: number): number[] {
        const st = focusIndex - bufferCount
        const ed = focusIndex + visibleCount + bufferCount
        const arr: Set<number> = new Set([])
        for (let i = st; i < ed; i++) {
            let val: number = i
            if (i < 0) {
                val = orginalArray.length + i
            }
            if (i > orginalArray.length - 1) {
                val = i % orginalArray.length
            }
            arr.add(val)
        }
        return Array.from(arr)
    }

    /**
     * return the time range (1 day +/- 3hrs ) for epg time range display
     * and filter the programs to be displayed in epg.
     *
     * @returns {{ startDate: Date, endDate: Date }}
     */
    getTimeRange(): { startDate: Date, endDate: Date } {
        const startTime: Date = EPGUtility.getDeviceCurrentDateTime()
        startTime.setMinutes(0, 0, 0)
        startTime.setHours(startTime.getHours())
        const endTime = new Date(startTime)
        endTime.setHours(startTime.getHours() + 24)
        return {
            startDate: startTime,
            endDate: endTime
        }
    }

    destroy() {

    }
}
